export const FETCH_RIDES_REQUEST = "FETCH_RIDES_REQUEST";
export const FETCH_RIDES_SUCCESS = "FETCH_RIDES_SUCCESS";
export const FETCH_RIDES_FAILURE = "FETCH_RIDES_FAILURE";
export const FETCH_SINGLE_RIDE_SUCCESS = "FETCH_SINGLE_RIDE_SUCCESS";
export const FETCH_SINGLE_RIDE_FAILURE = "FETCH_SINGLE_RIDE_FAILURE";
